const isAvailable = () => {
  try {
    return typeof sessionStorage !== 'undefined';
  } catch (e) {
    return false;
  }
};

const getItem = (key, defaultValue = null) => {
  try {
    if (isAvailable()) {
      const value = sessionStorage.getItem(key);
      return value !== null ? value : defaultValue;
    }
  } catch (e) {
    // ignore
  }
  return defaultValue;
};

const setItem = (key, value) => {
  try {
    if (isAvailable()) {
      const val = typeof value === 'object' && value !== null ? JSON.stringify(value) : String(value);
      sessionStorage.setItem(key, val);
      return true;
    }
  } catch (e) {
    // ignore
  }
  return false;
};

const addItem = (key, value) => setItem(key, value);

const editItem = (key, value) => setItem(key, value);

const removeItem = (key) => {
  try {
    if (isAvailable()) {
      sessionStorage.removeItem(key);
      return true;
    }
  } catch (e) {
    // ignore
  }
  return false;
};

const clear = () => {
  try {
    if (isAvailable()) {
      sessionStorage.clear();
      return true;
    }
  } catch (e) {
    // ignore
  }
  return false;
};

const getJSON = (key, defaultValue = null) => {
  try {
    const item = getItem(key);
    if (item !== null && item !== undefined) {
      return JSON.parse(item);
    }
  } catch (e) {
    // ignore
  }
  return defaultValue;
};

const setJSON = (key, value) => setItem(key, value);

const sessionStorageHelper = {
  isAvailable,
  getItem,
  setItem,
  addItem,
  editItem,
  removeItem,
  clear,
  getJSON,
  setJSON,
  get: getItem,
  set: setItem,
  add: addItem,
  edit: editItem,
  remove: removeItem,
};

export {
  isAvailable,
  getItem,
  setItem,
  addItem,
  editItem,
  removeItem,
  clear,
  getJSON,
  setJSON,
};

export default sessionStorageHelper;
